import { doPost, doGet, doDelete, doPut } from '../../tools/axios'

export default {
  getMomentList (category, hashTagId, page, maxMomentId, perPage = 10) {
    return doGet('/moments', {
      category,
      hash_tag_id: hashTagId,
      page,
      perPage,
      max_moment_id: maxMomentId
    })
  },
  getUserMomentList (userId, page, perPage = 10) {
    return doGet('/moments', {
      moment_user_id: userId,
      page,
      perPage
    })
  },
  publishMoment (content, images, type, objectId, tags, atUsers, video) {
    return doPost('/moments', {
      content,
      images,
      type,
      hash_tags: tags,
      object_id: objectId,
      at_users: atUsers,
      video
    })
  },
  updateMoment (momentId, data) {
    return doPut(`/moments/${momentId}`, data)
  },
  getMomentDetail (momentId) {
    return doGet(`/moments/${momentId}`)
  },
  like (momentId, isLike) {
    return doPost(isLike ? '/moments/like' : '/moments/dislike', {
      moment_id: momentId
    })
  },
  comment (momentId, content, image, atUsers) {
    return doPost('/moment_comments', {
      moment_id: momentId,
      content,
      image,
      at_users: atUsers
    })
  },
  replyComment (momentId, content, image, replyToUserId, atUsers) {
    return doPost('/moment_comments/reply', {
      moment_id: momentId,
      content,
      image,
      reply_to_user_id: replyToUserId,
      at_users: atUsers
    })
  },
  getMomentCommentList (momentId, page, perPage = 20) {
    return doGet('/moment_comments', {
      moment_id: momentId,
      page,
      perPage
    })
  },
  getMomentLikeList (momentId, page, perPage = 20) {
    return doGet('/moment_likes', {
      moment_id: momentId,
      page,
      perPage
    })
  },
  getMomentNotify (page, perPage = 10) {
    return doGet('/moment_notifications', {
      page,
      perPage
    })
  },
  getMomentNotifyUnreadCount () {
    return doGet('/moment_notifications/unread_count')
  },
  deleteMoment (momentId) {
    return doDelete(`/moments/${momentId}`)
  },
  deleteComment (commentId) {
    return doDelete(`/moment_comments/${commentId}`)
  },
  changeMomentBanner (momentBannerImage) {
    return doPost('/user/changeMomentBanner', {
      moment_banner_image: momentBannerImage
    })
  },
  getMomentRecommendUsers () {
    return doGet('/moments/recommend_users')
  }
}
